import React from "react";
import { ECLSelect } from "../../../index";

export default function TableStringFilter(props) {
   return (
      <div className="table-select-container">
         <ECLSelect
            multiselect={true}
            filter={true}
            options={props.options}
            setOptions={props.setFilterFunction}
            customTrigger={props.customTrigger}
            inModal={props.inModal}
            containerId={props.containerId}
            menuWidth={300}
         />
      </div>
   );
}
